
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
// import AppLoadingButton from "@/components/mui/LoadingButton";

export default function AboutUs() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return <div>
    About Us
  </div>
}